var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-459.749 -39.853)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 0.004,
    height: 3.317,
    transform: "translate(481.845 58.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 0.004,
    height: 3.317,
    transform: "translate(481.845 58.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M511.5,67.183a6.621,6.621,0,0,1-1.88,4.662A6.6,6.6,0,0,1,511.5,76.5v.562a6.244,6.244,0,0,1-6.03,6.424h-3.047V79.954h3.047a2.807,2.807,0,0,0,2.713-2.89V76.5a2.807,2.807,0,0,0-2.713-2.89H503.75V70.078h1.719a2.811,2.811,0,0,0,2.713-2.895v-.558a2.811,2.811,0,0,0-2.713-2.895h-4.114v5.1h0v5.408h0v9.044h-3.317V73.612h-4.319V70.078h4.319v-9.9h3.317V60.2h4.114a6.245,6.245,0,0,1,6.03,6.428Z",
    transform: "translate(-19.355 -12.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M499.749,79.853h-40v-40h40Zm-36.56-3.44h33.121V43.293H463.188Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 3.317,
    height: 22.967,
    transform: "translate(468.022 48.186)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cbaef21955988ce3ba748a7658940f3f.svg";
export { ForwardRef as ReactComponent };